import axios from "axios";

import { ResponseWrapper } from "@teamprevent/common/utils";

import { CustomerDocumentListModel, CustomerDocumentDetailModel, CustomerDocumentCreateModel, CustomerDocumentEditModel } from "./model";

class CustomerDocumentApi {

    private readonly apiUrl = "/api/customer";
    private readonly customerDocumentApiSegment = "customerDocument";

    public async getAll(customerId: string): Promise<CustomerDocumentListModel[]> {
        const response = await axios.get(`${this.apiUrl}/${customerId}/${this.customerDocumentApiSegment}`);
        const data = response.data as CustomerDocumentListModel[];
        return data.map(this.parseModel);
    }

    public async detail(customerId: string, id: any): Promise<CustomerDocumentDetailModel> {
        const response = await axios.get(`${this.apiUrl}/${customerId}/${this.customerDocumentApiSegment}/${id}`);
        const model = response.data as CustomerDocumentDetailModel;
        return this.parseModel(model);
    }

    public async save(customerId: string, customerDocument: CustomerDocumentEditModel): Promise<ResponseWrapper<CustomerDocumentDetailModel>> {
        const response = await axios.put(`${this.apiUrl}/${customerId}/${this.customerDocumentApiSegment}/${customerDocument.id}`, customerDocument);
        const model = response.data as ResponseWrapper<CustomerDocumentDetailModel>;
        return model;
    }

    public async create(customerId: string, customerDocument: CustomerDocumentCreateModel): Promise<ResponseWrapper<CustomerDocumentDetailModel>> {
        const response = await axios.post(`${this.apiUrl}/${customerId}/${this.customerDocumentApiSegment}`, customerDocument);
        const model = response.data as ResponseWrapper<CustomerDocumentDetailModel>;
        return model;
    }

    public delete(customerId: string, id: string): Promise<void> {
        return axios.delete(`${this.apiUrl}/${customerId}/${this.customerDocumentApiSegment}/${id}`);
    }

    public parseModel(model: CustomerDocumentDetailModel): CustomerDocumentDetailModel {
        return {
            ...model
        };
    }

    public async uploadDocument(customerId: string, attachment: { fileId: string; data: Blob }) {
        const data = new FormData();
        data.append("file", attachment.data);
        const response = await axios.post<string>(`${this.apiUrl}/${customerId}/${this.customerDocumentApiSegment}/uploadDocument/${attachment.fileId}`, data);
        return response.data;
    }
}

export default new CustomerDocumentApi();
